export function typeToName(type) {
    switch (type) {
        case 'bundled':
            return 'Bundled';
        case 'marketplace':
            return 'Marketplace';
        case 'internal-repo':
            return 'Corporate repository';
        default:
            return assert_exhaustive(type);
    }
}
